import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import Feedbacks from '../common/Feedbacks';
import { putRequest, postRequest } from '../../requestUtils';
import checkmarkImg from '../../../assets/images/check-mark.svg';
import './ProposalFeedbacks.scss';

const renderCheckmark = (showImage) => (showImage
  ? <img src={checkmarkImg} className="checkmark-img" alt="check mark" /> : null);

class ProposalFeedbacks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.id === null,
      isUpdate: props.id !== null,
      note: props.note,
      showModal: props.showModal,
      feedbacks: props.feedbacks,
      isProcessing: false,
      consultantFit: props.consultantFit,
      id: props.id,
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.updateFeedbackState = this.updateFeedbackState.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { feedbacks, modalIsOpen } = this.props;

    // Compare the previous feedbacks with the current feedbacks to check for changes
    const feedbacksChanged = feedbacks.some((feedback) => {
      const prevFeedback = prevProps.feedbacks.find((f) => f.id === feedback.id);

      return (
        !prevFeedback
        || prevFeedback.note !== feedback.note
        || prevFeedback.consultant_fit !== feedback.consultant_fit
      );
    });

    if (!prevProps.modalIsOpen && modalIsOpen) {
      this.handleShowModal();
    } else if (prevProps.feedbacks !== feedbacks || feedbacksChanged) {
      this.updateFeedbackState();
    }
  }

  handleShowModal() {
    this.props.showModalCallback();
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleInputChange(input, value) {
    this.setState({ [input]: value });
  }

  handleOptionClick(event, value) {
    event.preventDefault();

    this.setState({ consultantFit: value });
  }

  handleSubmit(isUpdate) {
    const {
      note, feedbacks, consultantFit, id,
    } = this.state;
    const oldFeedbacks = feedbacks;
    const {
      proposalResourceId,
      csrfToken,
      email,
      handleProposalAfterSubmit,
      showNewProposalUX,
    } = this.props;
    this.setState({ isProcessing: true });
    if (isUpdate) {
      putRequest(
        `/proposals/${proposalResourceId}/proposal_feedbacks/${id}`,
        { proposal_feedback: { consultant_fit: consultantFit, note, email } },
        csrfToken,
      ).then(({ data }) => {
        const updatedFeedbacks = feedbacks
          .map((item) => (item.id === data.feedback.id
            ? { ...item, ...data.feedback } : item));
        this.setState({
          feedbacks: updatedFeedbacks,
          isProcessing: false,
          showModal: false,
          isUpdate: true,
          edit: false,
          id: data.id,
        });
        if (showNewProposalUX) {
          handleProposalAfterSubmit(data.proposalDetails);
        }
      }).catch(() => {
        this.setState({ isProcessing: false });
      });
    } else {
      postRequest(
        `/proposals/${proposalResourceId}/proposal_feedbacks/`,
        { proposal_feedback: { consultant_fit: consultantFit, note, email } },
        csrfToken,
      ).then(({ data }) => {
        this.setState({
          feedbacks: oldFeedbacks.concat(data.feedback),
          isProcessing: false,
          showModal: false,
          isUpdate: true,
          edit: false,
          id: data.id,
        });
      }).catch(() => {
        this.setState({ isProcessing: false });
      });
    }
  }

  updateFeedbackState() {
    const {
      feedbacks, id, note, consultantFit,
    } = this.props;

    this.setState({
      edit: id === null,
      isUpdate: id !== null,
      note,
      feedbacks,
      consultantFit,
      id,
    });
  }

  renderForm() {
    const { candidateName } = this.props;
    const {
      note, isUpdate, isProcessing, consultantFit,
    } = this.state;
    return (
      <form className="feedback-form">
        <h2 className="header">
          {`Is ${candidateName} a good fit for this project?`}
        </h2>
        <div className="sub-header">
          <strong>Only team members</strong>
          {' '}
          will see your feedback.
        </div>
        <div className="button-group">
          <button
            className={`option-button ${consultantFit === 'yes' ? 'selected' : ''}`}
            onClick={(event) => this.handleOptionClick(event, 'yes')}
          >
            {renderCheckmark(consultantFit === 'yes')}
            Yes
          </button>
          <button
            className={`option-button ${consultantFit === 'maybe' ? 'selected' : ''}`}
            onClick={(event) => this.handleOptionClick(event, 'maybe')}
          >
            {renderCheckmark(consultantFit === 'maybe')}
            Maybe
          </button>
          <button
            className={`option-button ${consultantFit === 'no' ? 'selected' : ''}`}
            onClick={(event) => this.handleOptionClick(event, 'no')}
          >
            {renderCheckmark(consultantFit === 'no')}
            No
          </button>
        </div>
        <div className="fs-hide mb-2">
          <textarea
            value={note !== null ? note : ''}
            className="form-control"
            placeholder="Type your comments here..."
            name="note"
            id="note"
            rows="4"
            onChange={(event) => this.handleInputChange('note', event.target.value)}
          />
        </div>
        <div className="form-actions">
          {isUpdate
            && (
            <button
              className="btn btn-secondary-no-border me-2 cancel-edit-feedback"
              type="button"
              onClick={() => this.handleCloseModal()}
            >
              Cancel
            </button>
            )}
          <button
            className={
              `btn ${consultantFit === null ? 'btn-disabled' : 'btn-primary'}`
}
            type="button"
            onClick={() => { this.handleSubmit(isUpdate); }}
            disabled={consultantFit === '' && isUpdate === false}
          >
            {isUpdate ? 'Update Feedback' : 'Submit Feedback'}
            {isProcessing ? '...' : ''}
          </button>
        </div>
      </form>
    );
  }

  renderFeedbacks() {
    const {
      csrfToken,
      proposalResourceId,
      emailShareUrl,
      candidateName,
      location,
      canEditFeedback,
      admin,
      buttonStyles,
      handleShowCoworkerModal,
      showNewProposalUX,
    } = this.props;
    const { feedbacks, edit } = this.state;
    return (
      <div className="proposal-feedbacks-container">
        <div className="proposal-feedbacks">
          <div className="comments-and-colleagues-collapsible show">
            <h2 className={`demibold mb-4 ${buttonStyles} `}>
              Team feedback on
              {' '}
              {candidateName}
            </h2>
            {feedbacks.length === 0
              ? (
                <div className="empty-feedback">
                  No feedback yet. Tell your colleagues what you think to get the ball rolling,
                  or invite them to leave their own feedback.
                </div>
              )
              : (
                <Feedbacks
                  canCreateFeedback={false}
                  feedbacks={feedbacks}
                  csrfToken={csrfToken}
                  resource="proposal"
                  resourceId={proposalResourceId}
                  emailShareUrl={emailShareUrl}
                />
              )}
            <br />
            { location === 'proposal'
            && (
            <div className="btn-actions">
              {(!admin && canEditFeedback && edit)
                && (
                <Button
                  className="btn-add-feedback"
                  onClick={this.handleShowModal}
                >
                  Leave feedback
                </Button>
                )}
              {
                showNewProposalUX
                  ? (
                    <Button
                      onClick={() => handleShowCoworkerModal()}
                      tabIndex={0}
                      className="btn-add-coworkers-feedback"
                    >
                      Share with a Colleague
                    </Button>
                  )
                  : (
                    <Button
                      onClick={() => ($('.add-coworkers-button').click())}
                      tabIndex={0}
                      className="btn-add-coworkers-feedback"
                    >
                      Share with a Colleague
                    </Button>
                  )
              }
            </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { canEditFeedback, admin, location } = this.props;
    const { edit, showModal } = this.state;

    return (
      <div className="add-proposal-feedback-container style-guide box-shadow-1">
        {(!admin && canEditFeedback && edit && location === 'resume') && this.renderForm()}
        {location === 'proposal' && this.renderFeedbacks()}
        <Modal
          show={showModal}
          onHide={this.handleCloseModal}
          backdrop="static"
          className="edit-feedback-modal"
          size="lg"
        >
          <Modal.Header closeButton className="no-border-bottom edit-feedback-modal-close" />
          <Modal.Body>
            {this.renderForm()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ProposalFeedbacks.propTypes = {
  canEditFeedback: PropTypes.bool.isRequired,
  candidateName: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  email: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  admin: PropTypes.bool,
  emailShareUrl: PropTypes.string,
  consultantFit: PropTypes.string,
  note: PropTypes.string,
  location: PropTypes.string,
  buttonStyles: PropTypes.string,
  handleShowCoworkerModal: PropTypes.func,
  showModal: PropTypes.bool,
  showModalCallback: PropTypes.func,
  modalIsOpen: PropTypes.bool,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool,
};

ProposalFeedbacks.defaultProps = {
  consultantFit: '',
  note: null,
  location: 'proposal',
  admin: false,
  emailShareUrl: '',
  buttonStyles: '',
  showModal: false,
  handleShowCoworkerModal: () => {},
  showModalCallback: () => {},
  handleProposalAfterSubmit: () => {},
  modalIsOpen: false,
  showNewProposalUX: false,
};

export default ProposalFeedbacks;
